import AdminStatisticPage from '@/pages/admin/AdminStatisticPage/AdminStatisticPage.vue'

export default AdminStatisticPage
